export const dispatch = {
  main: "Schedule",
};
